<template>
  <div>
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <div class="modal-body">
              <slot name="body">
                <iframe
                  width="100%"
                  height="315"
                  v-bind:src="linkvideo"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </slot>
            </div>
            <div class="modal-footer">
              <slot name="footer">
                <!-- desabilitar modal para não aparecer mais -->
                <button
                  class="modal-default-button"
                  @click="$emit('nao-exibir-ajuda')"
                >
                  Não exibir ajuda
                </button>
                <!-- fechar modal -->
                <button
                  class="modal-default-button"
                  @click="$emit('close-modal-ajuda')"
                >
                  Fechar
                </button>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'ModalAjuda',
  props: {
    linkvideo: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
}
</script>

<style lang="css"></style>
